import axios from "axios";
import { API_BASE } from "../../../config/api";
import getUserInfo from "../../../utilities/decodeJwt";

export const saveScore = async (score, gameMode) => {
  try {
    const userInfo = getUserInfo();
    if (!userInfo) {
      alert("You must be logged in to save your score.");
      return;
    }

    let url;

    switch (gameMode) {
    case "normal":
        url = `${API_BASE}/api/game/${userInfo.id}/score`;
        break;
    case "hard":
        url = `${API_BASE}/api/hardGame/${userInfo.id}/score`;
        break;
    case "daily":
        url = `${API_BASE}/api/dailyLeaderboard/${userInfo.id}/score`;
        break;
    default:
        throw new Error(`Unknown game mode: ${gameMode}`);
  }
    await axios.post(url, {
      userId: userInfo.id,
      username: userInfo.username,
      score,
  });
  } catch (error) {
    console.error("Error saving score:", error);
  }
};

